import React from "react";
import { IconT } from "types/utils";

const DownCaretThicker = ({ fill = "white", height = "12", width = "8" }: IconT) => {
  return (
    <svg width={width} height={height} viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="2.33203"
        y="0.919922"
        width="6.98973"
        height="1.45619"
        rx="0.25"
        transform="rotate(45 2.33203 0.919922)"
        fill={fill}
        stroke={fill}
        strokeWidth="0.5"
      />
      <rect
        x="11.2012"
        y="1.9502"
        width="6.98973"
        height="1.45619"
        rx="0.25"
        transform="rotate(135 11.2012 1.9502)"
        fill={fill}
        stroke={fill}
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default DownCaretThicker;
